import { render } from "./ExternalPage.vue?vue&type=template&id=3cc95440&scoped=true&ts=true"
import script from "./ExternalPage.vue?vue&type=script&lang=ts"
export * from "./ExternalPage.vue?vue&type=script&lang=ts"

import "./ExternalPage.vue?vue&type=style&index=0&id=3cc95440&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc95440"]])

export default __exports__